import { DEVICE_TYPE, PAGE_NAMES } from "../../../constants";
import { CLIENT_URLS } from "constants/urls";
import { trackPaymentMethodClick } from "layouts/Payment/common/dependencies/tracking";

export const getOtherPaymentOptionConfig = (history: any, isGuest: boolean) => {
  return [
    {
      mode: "cards",
      leadIcon:
        "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DesktopRevamp_icons/card-debit-credit-24_2.svg",
      endIcon: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Right.svg",
      label: "Credit/ Debit Card",
      clickHandler: () => {
        trackPaymentMethodClick({
          paymentMethod: "Cards",
          isSaved: false,
          deviceType: DEVICE_TYPE.MOBILE,
          isLoggedIn: !isGuest,
          interactionLocation: PAGE_NAMES.PAYMENT_BOTTOMSHEET
        });
        history.replace(`${CLIENT_URLS.PAYMENT_BASE_URL}?screen=newPayment&method=cc`);
      },
    },
    {
      mode: "",
      leadIcon: "https://images-static.nykaa.com/media/desktop-icons/Icon.svg",
      endIcon: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Right.svg",
      label: "Other payment method",
      clickHandler: () => {
        trackPaymentMethodClick({
          paymentMethod: "other_payment_method",
          isSaved: false,
          deviceType: DEVICE_TYPE.MOBILE,
          isLoggedIn: !isGuest,
          interactionLocation: PAGE_NAMES.PAYMENT_BOTTOMSHEET
        });
        history.replace(`${CLIENT_URLS.PAYMENT_BASE_URL}?screen=newPayment`);
      },
    },
  ];
};
